import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, mergeProps as _mergeProps, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-00f34394"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "report-config-page" }
const _hoisted_2 = { class: "ws_common_operation" }
const _hoisted_3 = { class: "table ws_common_table" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "dialog-footer" }

import { onMounted, ref } from 'vue'
import AdvancedQueryLayout from '@/components/advanced-query-layout'
import { useDeviceStore } from '@/stores/device'
import { queryReportConfig } from '@/api'
import ReportConfForm from './components/report-config-form-drawer.vue'
import { isEmpty } from 'lodash'
import moment from 'moment'
import { useRoute } from 'vue-router'
import { CODE_ENUM, PAGE_SIZES } from '@/common'
import { ElMessage } from 'element-plus'
import i18n from '@/i18n'
import OperationButtonList from '@/components/operation-button-list'
import { deleteReportConfig, stopReportConfig, startReportConfig } from '@/api'
import { msgbox } from '@/utils'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const t = i18n.global.t

const getButtonList = ({ enableStatus }: any) => {
  return [
    {
      type: 'detail',
      text: enableStatus
        ? t('STATISTICS.reportStatus0')
        : t('STATISTICS.reportStatus1'),
    },
    {
      type: 'edit',
      text: t('STATISTICS.bedit'),
    },
    {
      type: 'delete',
      text: t('STATISTICS.delete'),
    },
  ]
}

const deviceStore = useDeviceStore()
deviceStore.queryDeviceOps()

const $route = useRoute()

const advancedRef = ref()

const formInline: any = ref({
  reportName: undefined,
})

onMounted(async () => {
  fetchList()
})

const handleSizeChange = () => {
  pageParams.value.curPage = 1
  fetchList()
}
const handleCurrentChange = () => {
  fetchList()
}

const pageParams = ref({
  curPage: 1,
  pageSize: 10,
})
const total = ref(0)
const columns: any = [
  {
    label: t('STATISTICS.reportName'),
    prop: 'reportName',
  },
  {
    label: t('STATISTICS.dateType'),
    prop: 'dataType',
  },
  {
    label: t('STATISTICS.executionType'),
    prop: 'executeDesc',
  },
]

const tableData = ref([])
const tableLoading = ref(false)
const fetchList = async (queryData?: any) => {
  const keepAliveData = advancedRef.value.getKeepAliveData() || {}
  const { data, reset } = queryData || {}
  if (typeof reset === 'boolean') {
    pageParams.value.curPage = 1
  }
  tableLoading.value = true
  const res: any = await queryReportConfig({
    ...pageParams.value,
    ...data,
    ...keepAliveData,
  }).finally(() => {
    tableLoading.value = false
  })
  if (res?.code === CODE_ENUM.SUCCESS) {
    total.value = res?.data?.total || 0
    tableData.value = res?.data?.records || []
  }
}

const handleForm = (data = {}) => {
  formConf.value = {
    visible: true,
    data,
  }
}

const formConf = ref({
  visible: false,
  data: {},
})

const toDelete = (row: any) => {
  msgbox({
    tip: t('STATISTICS.confDelTip'),
    thenFn: () => handleDelete(row),
  })
}

const handleDelete = async ({ id }: any) => {
  const res: any = await deleteReportConfig({ id })
  if (res?.code === CODE_ENUM.SUCCESS) {
    ElMessage.success(res?.msg)
    fetchList()
  }
}

const toChangeStatus = async ({ enableStatus, id }: any) => {
  const fn = enableStatus ? stopReportConfig : startReportConfig
  const res: any = await fn({ id })
  if (res?.code === CODE_ENUM.SUCCESS) {
    ElMessage.success(res?.msg)
    fetchList()
  }
}

const deviceData: any = ref([])
const dialogVisible = ref(false)

const toViewDevice = ({ executeDevice, executeAttribute }: any) => {
  deviceData.value = [
    {
      executeDevice,
      executeAttribute,
    },
  ]
  dialogVisible.value = true
}

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_unref(AdvancedQueryLayout), {
        class: "advanced-wrapper",
        ref_key: "advancedRef",
        ref: advancedRef,
        model: formInline.value,
        onFetchList: fetchList,
        border: true
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            label: _ctx.$t('STATISTICS.reportName'),
            prop: "reportName"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: formInline.value.reportName,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formInline.value.reportName) = $event)),
                placeholder: _ctx.$t('STATISTICS.selectPla'),
                class: "ws_select",
                clearable: ""
              }, null, 8, ["modelValue", "placeholder"])
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _: 1
      }, 8, ["model"]),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_button, {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (handleForm())),
          type: "primary"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('STATISTICS.reportConfNew')), 1)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_3, [
        _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          data: tableData.value,
          style: {"width":"100%"}
        }, {
          empty: _withCtx(() => [
            _createVNode(_component_el_empty, {
              description: _ctx.$t('STATISTICS.noData')
            }, null, 8, ["description"])
          ]),
          default: _withCtx(() => [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(columns, (item) => {
              return _createVNode(_component_el_table_column, _mergeProps({
                key: item.prop
              }, {
            ...item,
          }, { "show-overflow-tooltip": "" }), null, 16)
            }), 64)),
            _createVNode(_component_el_table_column, {
              label: _ctx.$t('STATISTICS.executionDevice')
            }, {
              default: _withCtx((scoped) => [
                _createElementVNode("a", {
                  onClick: ($event: any) => (toViewDevice(scoped.row))
                }, _toDisplayString(_ctx.$t('STATISTICS.viewDevice')), 9, _hoisted_4)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              label: _ctx.$t('STATISTICS.reportStatus'),
              prop: "enableStatus",
              "show-overflow-tooltip": ""
            }, {
              default: _withCtx((scoped) => [
                (scoped.row.enableStatus)
                  ? (_openBlock(), _createBlock(_component_el_tag, { key: 0 }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('STATISTICS.reportStatus1')), 1)
                      ]),
                      _: 1
                    }))
                  : (_openBlock(), _createBlock(_component_el_tag, {
                      key: 1,
                      type: "info"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('STATISTICS.reportStatus0')), 1)
                      ]),
                      _: 1
                    }))
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              label: _ctx.$t('STATISTICS.operation'),
              prop: "enableStatus",
              width: "380"
            }, {
              default: _withCtx((scoped) => [
                _createVNode(_unref(OperationButtonList), {
                  buttonList: getButtonList(scoped.row),
                  scope: scoped.row,
                  onOnDelete: toDelete,
                  onOnDetail: toChangeStatus,
                  onOnEdit: handleForm
                }, null, 8, ["buttonList", "scope"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        }, 8, ["data"])), [
          [_directive_loading, tableLoading.value]
        ]),
        _createVNode(_component_el_pagination, {
          class: "ws_mt50",
          "current-page": pageParams.value.curPage,
          "onUpdate:currentPage": _cache[2] || (_cache[2] = ($event: any) => ((pageParams.value.curPage) = $event)),
          "page-size": pageParams.value.pageSize,
          "onUpdate:pageSize": _cache[3] || (_cache[3] = ($event: any) => ((pageParams.value.pageSize) = $event)),
          "page-sizes": _unref(PAGE_SIZES),
          layout: "->, total, sizes, prev, pager, next, jumper ",
          total: total.value,
          onSizeChange: handleSizeChange,
          onCurrentChange: handleCurrentChange
        }, null, 8, ["current-page", "page-size", "page-sizes", "total"])
      ]),
      _createVNode(ReportConfForm, {
        visible: formConf.value.visible,
        "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((formConf.value.visible) = $event)),
        data: formConf.value.data,
        onSuccess: fetchList
      }, null, 8, ["visible", "data"])
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: dialogVisible.value,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((dialogVisible).value = $event)),
      title: _ctx.$t('STATISTICS.viewTitle'),
      width: "435px"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_5, [
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (dialogVisible.value = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('STATISTICS.yes')), 1)
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_table, {
          data: deviceData.value,
          class: "ws_common_table"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              prop: "executeDevice",
              label: _ctx.$t('STATISTICS.device')
            }, null, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              prop: "executeAttribute",
              label: _ctx.$t('STATISTICS.var')
            }, null, 8, ["label"])
          ]),
          _: 1
        }, 8, ["data"])
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ], 64))
}
}

})